import { render, staticRenderFns } from "./DeparturesTableFlorianopolis.vue?vue&type=template&id=03cc65b1&scoped=true&"
import script from "./DeparturesTableFlorianopolis.vue?vue&type=script&lang=js&"
export * from "./DeparturesTableFlorianopolis.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesTableFlorianopolis.vue?vue&type=style&index=0&id=03cc65b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc65b1",
  null
  
)

export default component.exports